import { useEffect } from 'react';

/**
 * Хук для обновления высоты iframe внутри контейнера по сообщению через postMessage.
 *
 * @param containerId - Идентификатор контейнера, внутри которого находится iframe.
 * @param trustedOrigin - (Опционально) Доверённый источник, с которого принимаются сообщения.
 */
export const useIframeHeightUpdater = (containerId: string, trustedOrigin?: string) => {
	useEffect(() => {
		const messageHandler = (event: MessageEvent) => {
			// Если передан trustedOrigin, проверяем источник сообщения
			if (trustedOrigin && event.origin !== trustedOrigin) return;

			// Проверяем, что event.data существует и содержит height
			if (event.data && typeof event.data.height !== 'undefined') {
				const container = document.getElementById(containerId);
				if (container) {
					const iframe = container.querySelector('iframe');
					if (iframe) {
						iframe.style.height = event.data.height + 'px';
					}
				}
			}
		};

		window.addEventListener('message', messageHandler, false);

		return () => {
			window.removeEventListener('message', messageHandler);
		};
	}, [containerId, trustedOrigin]);
};